import * as core from '../../../../../../../core'

import { query } from './design-specs-table.query'

export const RESOURCE = {
  payload: {
    alias: 'design.specs.table',
    description: 'Table view of specs and their approval state',
    name: 'Design Specs Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
